<template>
  <div style="height: 100%">

  <div :class="[isPC || isTablet ? 'home-pc' : 'home-mb']">
    <div class="container">
      <meeting-detail @showWXFnc="showWX"></meeting-detail>
    </div>
    <van-dialog v-model="showWXCode" :showConfirmButton="false" width="270">
      <div class="showWXCode">
        <van-icon name="cross" @click="closeWXCode" color="#A3A3A3" class="showWXCode_closeIcon" />
        <img :src="wximgUrl" class="wximgUrl" referrerpolicy="no-referrer" />
        <div class="showWXCode_text">{{ $t('meeting.scan') }}</div>
        <div class="showWXCode_text showWXCode_text2">{{ $t('meeting.joinInMeeting') }}</div>
      </div>
    </van-dialog>
    <!-- 微信浏览器提醒 -->
    <!-- <wechat-tips> </wechat-tips> -->
    <wechat-tips v-if="isWechat" :isShow="showWechatTips"> </wechat-tips>

  </div>
  </div>
</template>
<script>
import { isPC, isTablet, isWechat } from "@/utils";
// import { Dialog } from "vant";
import MeetingDetail from "@/views/meeting-detail";
import WechatTips from "@/components/wechat-tips";

export default {
  name: "home",
  data() {
    return {
      isPC: isPC(),
      isTablet: isTablet(),
      showWXCode: false,
      wximgUrl: "",
      isWechat: isWechat(),
      showWechatTips: false
    };
  },
  components: {
    MeetingDetail,
    WechatTips
  },
  methods: {
    showWX(wximgUrl) {
      this.wximgUrl = wximgUrl;
      this.showWXCode = true;
    },
    closeWXCode() {
      this.showWXCode = false;
    },
  },
  mounted() {
    this.$_dataRanger.send("page_view", {
      module: "视频会议",
      sub_module: "会议中转页",
      page_name: "会议中转页",
      page_path: "会议中转页",
    });
    // Dialog({
    //   message: this.isWechat ? 'isWechat true' : 'isWechat false',
    //   confirmButtonText: this.$t("common.ok"),
    //   confirmButtonColor: "#2496FF",
    //   width: "270px",
    //   className: "confirm-dialog",
    // });
    if (this.isWechat) {
      this.showWechatTips = true;
    }
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/home.less";

.van-dialog__content {
  width: 270px;
}
.showWXCode {
  position: relative;
  width: 100%;
  // height: 100%;
  padding: 32px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-right: 0 !important;

  .showWXCode_closeIcon {
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 16px;
  }
  .showWXCode_text {
    margin-top: 16px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC,sans-serif;
    font-weight: 400;
    color: #747577;
  }

  .showWXCode_text2 {
    margin-top: 12px;
  }
}
.wximgUrl {
  width: 180px;
  height: 180px;
}
</style>
